import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { Heading, Card, CardBody, Button, Text} from '@eggplant-finance/eggplant-uikit-theme'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import useI18n from 'hooks/useI18n'
import { useAllHarvest } from 'hooks/useHarvest'
import useFarmsWithBalance from 'hooks/useFarmsWithBalance'
import UnlockButton from 'components/UnlockButton'
import CakeHarvestBalance from './CakeHarvestBalance'
import CakeWalletBalance from './CakeWalletBalance'

const isMobile = window.innerWidth <= 600

const StyledFarmStakingCard = styled(Card)`
  /* padding: 60px; */
  padding: ${() => isMobile ? '0' : '60px'};

`

const Block = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: space-between;
`

const CardImage = styled.img`
  margin-bottom: 16px;
`

const Label = styled.div`
  color: ${({theme}) => theme.colors.textSubtle};
  font-size: 14px;
`

const Actions = styled.div`
  margin-top: 0px;
`

const ModiHeader = styled(Heading)`
  color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#460a80'};
`;

const ModiText = styled(Text)`
  color: ${({theme })=> theme.isDark ? '#e8e2fb' : '#460a80'};
`

const ModiUnlockButton = styled(UnlockButton)`
  background-color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#460a80' };
  color: ${({theme})=> theme.isDark ? '#460a80' : '#e8e2fb'};
  box-shadow: ${({theme})=> theme.isDark ? '0px 0px 5px 5px #460a80' : '0px 0px 5px 5px #e8e2fb'};
`

const ModiButton = styled(Button)`
  background-color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#460a80' };
  color: ${({theme})=> theme.isDark ? '#460a80' : '#e8e2fb'};
`

const ModiBlock = styled(Block)`
  display: flex;
  justify-content: space-between;
  
`

const FarmedStakingCard = () => {
  const [pendingTx, setPendingTx] = useState(false)
  const { account } = useWallet()
  const TranslateString = useI18n()
  const farmsWithBalance = useFarmsWithBalance()
  const balancesWithValue = farmsWithBalance.filter((balanceType) => balanceType.balance.toNumber() > 0)

  const { onReward } = useAllHarvest(balancesWithValue.map((farmWithBalance) => farmWithBalance.pid))

  const harvestAllFarms = useCallback(async () => {
    setPendingTx(true)
    try {
      await onReward()
    } catch (error) {
      // TODO: find a way to handle when the user rejects transaction or it fails
    } finally {
      setPendingTx(false)
    }
  }, [onReward])

  return (
    <StyledFarmStakingCard isTransparent>
      <CardBody>
        <ModiHeader size="xl" mb="24px">
          {TranslateString(542, 'Farms & Staking')}
        </ModiHeader>
        <ModiBlock>
          <ModiText fontSize="18px">{TranslateString(544, 'EGGP to Harvest')}</ModiText>  <CakeHarvestBalance />
        </ModiBlock>
        <ModiBlock>

          <ModiText fontSize="18px">{TranslateString(546, 'EGGP in Wallet')}</ModiText> <CakeWalletBalance/>
        </ModiBlock>
        <Actions>
          {account ? (
            <ModiButton id="harvest-all" fullwidth disabled={balancesWithValue.length <= 0 || pendingTx} onClick={harvestAllFarms}>
              {pendingTx
                ? TranslateString(548, 'Collecting EGGP')
                : TranslateString(1005, `Harvest all (${balancesWithValue.length})`)}
            </ModiButton>
          ) : (
            <ModiUnlockButton fullwidth />
          )}
        </Actions>
      </CardBody>
    </StyledFarmStakingCard>
  )
}

export default FarmedStakingCard
